import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

const routes = [{
		name: 'index',
		component: () => import("@/views/index/index.vue"),
		path: '/',
		meta: {layout: 'MainLayout'}
	},
	{
		component: () => import("@/views/pages/privacy-policy.vue"),
		path: '/pages/privacy-policy',
		meta: {layout: 'MainLayout'}
	},
	{
		component: () => import("@/views/pages/service-terms.vue"),
		path: '/pages/service-terms',
		meta: {layout: 'MainLayout'}
	},
	{
		component: () => import("@/views/ad/index.vue"),
		path: '/general-cross-border-shipping-and-overseas-warehouse-cargo-damage-insurance',
		meta: {layout: 'MainLayout'}
	},
	{
		component: () => import("@/views/user/login.vue"),
		path:'/login',
		meta: {layout: 'LoginLayout'}
	},
	{
		component: () => import("@/views/user/signup.vue"),
		path:'/signup',
		meta: {layout: 'LoginLayout'}
	},
	{
		component: () => import("@/views/user/cargo-signup.vue"),
		path:'/join-us',
		meta: {layout: 'LoginLayout'}
	},
	{
		component: () => import("@/views/user/reset-pwd.vue"),
		path:'/reset-pwd',
		meta: {layout: 'LoginLayout'}
	},
	{
		component: () => import("@/views/user/pwd-login.vue"),
		path:'/admin/login',
		meta: {layout: 'LoginLayout'}
	},
	{
		component: () => import("@/views/dashboard/index.vue"),
		path:'/dashboard',
		meta: {layout: 'DashboardLayout'}
	},
	{
		component: () => import("@/views/infos/company.vue"),
		path:'/infos/company',
		meta: {layout: 'DashboardLayout', types: []}
	},
	{
		component: () => import("@/views/infos/staff/index.vue"),
		path:'/infos/staff',
		meta: {layout: 'DashboardLayout', types: ['CARGO_AGENT', 'MERCHANT']}
	},
	{
		component: () => import("@/views/merchant/product/index.vue"),
		path:'/merchant/product',
		meta: {layout: 'DashboardLayout', types: ['MERCHANT', 'MERCHANT_STAFF']}
	},
	{
		component: () => import("@/views/merchant/cargo-order/index.vue"),
		path:'/merchant/cargo-order',
		meta: {layout: 'DashboardLayout', types: ['MERCHANT', 'MERCHANT_STAFF', 'CARGO_AGENT', 'CARGO_AGENT_STAFF', 'PARTNER']}
	},
	{
		component: () => import("@/views/merchant/order/index.vue"),
		path:'/merchant/order',
		meta: {layout: 'DashboardLayout', types: ['MERCHANT', 'MERCHANT_STAFF']}
	},
	{
		component: () => import("@/views/admin/partner/index.vue"),
		path:'/admin/partner',
		meta: {layout: 'DashboardLayout', types: ['ADMIN']}
	},
	{
		component: () => import("@/views/admin/rate-level/index.vue"),
		path:'/admin/rate-level',
		meta: {layout: 'DashboardLayout', types: ['ADMIN']}
	},
	{
		component: () => import("@/views/admin/data-board/index.vue"),
		path:'/admin/data-board',
		meta: {layout: 'DashboardLayout', types: ['ADMIN']}
	},
	{
		component: () => import("@/views/stat/earnings/index.vue"),
		path:'/stat/earnings',
		meta: {layout: 'DashboardLayout', types: ['CARGO_AGENT', 'CARGO_AGENT_STAFF', 'PARTNER']}
	},
	{
		component: () => import("@/views/merchant/product/add.vue"),
		path:'/merchant/product/add',
		meta: {layout: 'DefaultLayout'}
	},
	{
		component: () => import("@/views/merchant/cargo-order/confirm.vue"),
		path:'/merchant/cargo-order/confirm',
		meta: {layout: 'DefaultLayout'}
	},
	{
		component: () => import("@/views/merchant/cargo-order/request.vue"),
		path:'/merchant/cargo-order/request',
		meta: {layout: 'DefaultLayout'}
	},
	{
		component: () => import("@/views/merchant/cargo-order/list.vue"),
		path:'/merchant/cargo-order/list',
		meta: {layout: 'DefaultLayout'}
	},
	{
		component: () => import("@/views/upload/product.vue"),
		path:'/upload/product',
		meta: {layout: 'DefaultLayout'}
	},
	{
		component: () => import("@/views/infos/staff/add.vue"),
		path:'/infos/staff/add',
		meta: {layout: 'DefaultLayout'}
	},
	{
		component: () => import("@/views/admin/rate-level/levels.vue"),
		path:'/admin/rate-level/levels',
		meta: {layout: 'DefaultLayout'}
	},
	{
		component: () => import("@/views/admin/rate-level/level.vue"),
		path:'/admin/rate-level/level',
		meta: {layout: 'DefaultLayout'}
	},
	{
		component: () => import("@/views/admin/partner/info.vue"),
		path:'/admin/partner/info',
		meta: {layout: 'DefaultLayout'}
	},
	{
		path: '*',
		redirect: {
			name: 'index'
		}
	}
];

const router = new Router({
	mode: 'history',
	routes
});

router.beforeEach((to, from, next) => {
	var user = undefined
	try {
		user = JSON.parse(localStorage.getItem('USER'))
	} catch (e) {}
	const {meta: {layout, types}} = to
	if (!user && layout === 'DashboardLayout') {
		// 未登入
		return next(`/login?redirect_uri=${to.path}`)
	} else if (user) {
		const type = user.user?.type || ''
		if (layout === 'LoginLayout') {
			return next('/dashboard')
		} else if (layout === 'DashboardLayout' && types && types.indexOf(type)===-1) {
			return next('/dashboard')
		}
	}
	next()
})
export default router;